import { createAsyncThunk } from "@reduxjs/toolkit";
import { FaqService } from "@services/index";
import { getBaseUrl } from "../selectors/features";
import {
  FETCH_FAQ,
  DELETE_FAQ,
  ADD_FAQ,
  UPDATE_FAQ,
} from "@root/store/action-types";


const faqService = new FaqService();

export const getFaqs = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(FETCH_FAQ, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload } = requestPayload;

  const { data, error } = await faqService.fetchFaqs(
    baseUrl,
    payload
  );

  if (error) {
    onError(error, FETCH_FAQ);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data?.data, FETCH_FAQ);
  }
  return thunkAPI.fulfillWithValue(data);
});

export const doAddFaq = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(ADD_FAQ, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload } = requestPayload;

  const { data, error } = await faqService.addFaq(
    baseUrl,
    payload
  );
  
  if (error) {
    onError(data, ADD_FAQ);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, ADD_FAQ);
  }
  return thunkAPI.fulfillWithValue(data);
});

export const deleteFaq = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(DELETE_FAQ, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, id } = requestPayload;

  const { data, error } = await faqService.deleteFaq(
    baseUrl,
    id
  );

  if (error) {
    onError(error, DELETE_FAQ);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data?.rows, DELETE_FAQ);
  }
  return thunkAPI.fulfillWithValue(data);
});


export const updateFaq = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(UPDATE_FAQ, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload, id } = requestPayload;

  const { data, error } = await faqService.updateFaq(
    baseUrl,
    id,
    payload
  );

  if (error) {
    onError(error, UPDATE_FAQ);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, UPDATE_FAQ);

  }
  return thunkAPI.fulfillWithValue(data);
});